import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import React, { useContext, useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import KnowQuestextlogo from '../../assets/images/KQlogo.png';
import { AuthenticationContext } from '../../context/Authentication';
import useAuth from '../../hooks/useAuth';
import { SERVER_URL } from '../../util/EnvironmentConfig';
import LogoutIcon from '@mui/icons-material/Logout';

function Header() {
  const { auth, setAuth } = useAuth();
  const authentication = useContext(AuthenticationContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState(false);
  const [isBusiness, setIsBusiness] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  let userData = '';

  const token = localStorage.getItem('loginToken');
  if (token) userData = jwtDecode(token);

  useEffect(() => {
    setIsAdmin(userData?.role === 1);
    setIsBusiness(userData?.role === 5);
  }, [userData]);

  useEffect(() => {
    const handleScroll = () => {
      setIsMenuOpen(false);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const logout = () => {
    setAuth({});
    authentication.logout();
    navigate('/');
    localStorage.removeItem('loginToken');
    window.location.reload();
  };

  return (
    <header className="h-20 bg-white">
      <nav className="fixed top-0 left-0 w-full bg-primary z-50 border-b border-gray-700">
        <div className="max-w-screen-xl flex items-center justify-between mx-auto p-4">
          <a href="/" className="flex items-center space-x-3">
            <img
              src={KnowQuestextlogo}
              className="h-12 sm:h-14 md:h-16"
              alt="KnowQuest"
            />
          </a>
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-200 rounded-lg p-2"
          >
            <svg
              className="w-6 h-6"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 12h18M3 6h18M3 18h18" />
            </svg>
          </button>
          <div className="hidden md:flex items-center space-x-6">
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive
                  ? 'font-bold text-secondary border-b-2 border-secondary'
                  : 'text-white hover:text-secondary transition'
              }
            >
              Home
            </NavLink>
            {(auth?.email || userData?.email) &&
              (isBusiness ? (
                <></>
              ) : (
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-white hover:text-secondary transition'
                  }
                >
                  Dashboard
                </NavLink>
              ))}
            {(auth?.email || userData?.email) &&
              (isBusiness ? (
                <NavLink
                  to="/businessprofile"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-white hover:text-secondary transition'
                  }
                >
                  Business Profile
                </NavLink>
              ) : (
                <NavLink
                  to="/profile"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-white hover:text-secondary transition'
                  }
                >
                  Profile
                </NavLink>
              ))}
            <NavLink
              to="/contact-us"
              className={({ isActive }) =>
                isActive
                  ? 'font-bold text-secondary border-b-2 border-secondary'
                  : 'text-white hover:text-secondary transition'
              }
            >
              Contact
            </NavLink>
            {isAdmin && (
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  isActive
                    ? 'font-bold text-secondary border-b-2 border-secondary'
                    : 'text-white hover:text-secondary transition'
                }
              >
                Admin
              </NavLink>
            )}
            {auth?.email || userData?.email ? (
              <button
                onClick={logout}
                className="bg-secondary text-primary px-4 py-2  font-bold rounded-lg"
              >
                Logout <LogoutIcon />
              </button>
            ) : (
              <NavLink
                to="/login"
                state={{ from: location }}
                className={({ isActive }) =>
                  isActive
                    ? 'font-bold text-primary border-b-2 border-secondary bg-secondary  px-4 py-2 rounded-lg'
                    : 'bg-secondary text-white px-4 py-2 rounded-lg'
                }
              >
                Login / Register
              </NavLink>
            )}
          </div>
        </div>
        {isMenuOpen && (
          <div className="md:hidden bg-white shadow-md absolute w-full left-0 top-full flex flex-col space-y-4 py-4 px-6">
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive
                  ? 'font-bold text-secondary border-b-2 border-secondary'
                  : 'text-black hover:text-secondary transition'
              }
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </NavLink>
            {(auth?.email || userData?.email) &&
              (isBusiness ? (
                <NavLink
                  to="/businessquestion"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-black hover:text-secondary transition'
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Business Question
                </NavLink>
              ) : (
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-black hover:text-secondary transition'
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Dashboard
                </NavLink>
              ))}
            {(auth?.email || userData?.email) &&
              (isBusiness ? (
                <NavLink
                  to="/businessprofile"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-black hover:text-secondary transition'
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Business Profile
                </NavLink>
              ) : (
                <NavLink
                  to="/profile"
                  className={({ isActive }) =>
                    isActive
                      ? 'font-bold text-secondary border-b-2 border-secondary'
                      : 'text-black hover:text-secondary transition'
                  }
                  onClick={() => setIsMenuOpen(false)}
                >
                  Profile
                </NavLink>
              ))}
            <NavLink
              to="/contact-us"
              className={({ isActive }) =>
                isActive
                  ? 'font-bold text-secondary border-b-2 border-secondary'
                  : 'text-black hover:text-secondary transition'
              }
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </NavLink>
            {isAdmin && (
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  isActive
                    ? 'font-bold text-secondary border-b-2 border-secondary'
                    : 'text-gray-700 hover:text-secondary transition'
                }
                onClick={() => setIsMenuOpen(false)}
              >
                Admin
              </NavLink>
            )}
            {auth?.email || userData?.email ? (
              <button
                onClick={logout}
                className="bg-secondary text-white px-4 py-2 rounded-lg"
              >
                Logout <LogoutIcon />
              </button>
            ) : (
              <NavLink
                to="/login"
                state={{ from: location }}
                className={({ isActive }) =>
                  isActive
                    ? 'font-bold text-primary border-b-2 border-secondary bg-secondary  px-4 py-2 rounded-lg w-fit'
                    : 'bg-secondary text-black px-4 py-2 rounded-lg w-fit'
                }
              >
                Login / Register
              </NavLink>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}

export default Header;
